import { render, staticRenderFns } from "./Update-follow-up.vue?vue&type=template&id=5a8b4b60"
import script from "./Update-follow-up.vue?vue&type=script&lang=js"
export * from "./Update-follow-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports